/**
 * @author Ivan Toth.
 */
var bindDisErr = { section: '=' };
var DisplayErrorController = (function () {
    function DisplayErrorController(topic, Dialog) {
        this.topic = topic;
        this.Dialog = Dialog;
        this.hovered = false;
    }
    DisplayErrorController.prototype.showErrors = function (event) {
        var items;
        //Here to add the comment into the server
        //this.topic.clearTempComments();
        var title = 'Unknown';
        if (angular.isDefined(this.topic.topic.complete.errorsArray[this.section])) {
            var table = this.topic.topic.complete.errorsArray[this.section] || [];
            switch (this.section) {
                case 'bfCheck':
                    title = 'Brand Family Details Missing';
                    break;
                case 'goeCheck':
                case 'goeCheck_valid':
                    title = 'Find CMR/GOE Missing';
                    break;
                case 'complcl':
                    title = 'Completeness Checklist Missing';
                    break;
                case 'complcl2':
                    title = 'Government Checklist Missing';
                    break;
                case 'complcl3':
                    title = 'Duplicate Checklist Missing';
                    break;
                case 'dcCheck':
                    title = 'Duplicate Check Missing';
                    break;
                case 'goe_add_fields':
                    title = 'Government Determination';
                    break;
                case 'goePick':
                case 'goePick_valid':
                    title = 'Government Check Decision Missing';
                    break;
                case 'sap':
                    title = 'ODS Results Missing';
                    break;
                case 'complcl_validation':
                    title = 'Validation Checklist Missing';
                    break;
                case 'calculation':
                    title = 'Calculation Issues';
                    break;
                case 'complcl_calculation':
                    title = 'Calculation Checklist Missing';
                    break;
                case 'eligibilityGoeHistory':
                    title = 'GOE History Check';
                    break;
                case 'all':
                    title = 'All Missing';
                    break;
            }
            items = { title: title, table: table };
        }
        else {
            items = { title: title, table: [] };
        }
        this.Dialog.updateValidForm(event, items, 'dialog-missing-error.html');
    };
    DisplayErrorController.$inject = ['topic', 'Dialog'];
    return DisplayErrorController;
}());
var DisplayErrorComponent = (function () {
    function DisplayErrorComponent() {
        this.bindings = bindDisErr;
        this.templateUrl = 'display-missing-error.html';
        this.controller = DisplayErrorController;
    }
    return DisplayErrorComponent;
}());
angular
    .module('application')
    .component('displayError', new DisplayErrorComponent());

//# sourceMappingURL=detail.display.error.component.js.map
